import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "tir-pm-select-badge__icon-view" }
const _hoisted_2 = { class: "tir-pm-select-badge__sign" }
const _hoisted_3 = {
  key: 0,
  class: "tir-pm-select-badge__divider"
}

import { TirPmIconView } from "tir-pm-icon-view";
import { PropType, computed, useSlots } from "vue";
import { CrossCompactIcon } from "tir-style-system/icons/outline";
/**
 * Пропсы
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmSelectBadge',
  props: {
  /**
   * Выбираемый
   */
  isSelectable: { type: Boolean as PropType<boolean>, default: false },
  /**
   * Выбранный
   */
  isSelected: { type: Boolean as PropType<boolean>, default: false },
  /**
   * Закрываемый
   */
  isClosable: { type: Boolean as PropType<boolean>, default: false },
  /**
   * Произвольные параметры, передавамые при клике или закрытии
   */
  additionalParams: { type: Object as PropType<T> },
  /**
   * Обводка
   */
  isBordered: { type: Boolean as PropType<boolean>, default: false },
},
  emits: ["close", "select"],
  setup(__props, { emit }) {

const props = __props;





// /**
//  * Слоты
//  */
// const slots = useSlots();

/**
 * Стили на основе просов
 */
const computedClasses = computed(() => {
  return {
    "tir-pm-select-badge--selectable": props.isSelectable,
    "tir-pm-select-badge--selected": props.isSelected,
    "tir-pm-select-badge--bordered": props.isBordered,
  };
});

/**
//  * Есть ли слот для IconView
//  */
// const isWithIconViewAddon = computed(() => slots && slots.iconViewAddon && slots.iconViewAddon());
// /**
//  * Есть ли слот для текста
//  */
// const isWithSign = computed(() => slots && slots.sign && slots.sign());

/**
 * Обработчик закрытия с эмитом
 */
const onClose = () => {
  if (props.isClosable) {
    emit("close", props.additionalParams as T);
  }
};

/**
 * Обработчик выбора с эмитом
 */
const onSelect = () => {
  if (props.isSelectable) {
    emit("select", props.additionalParams as T);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tir-pm-select-badge", computedClasses.value]),
    onClick: onSelect
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "iconViewAddon")
    ]),
    _createElementVNode("span", _hoisted_2, [
      _renderSlot(_ctx.$slots, "sign")
    ]),
    (props.isClosable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3))
      : _createCommentVNode("", true),
    (props.isClosable)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "tir-pm-select-badge__close-button",
          onClick: onClose
        }, [
          _createVNode(_unref(CrossCompactIcon))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})